<!-- 
CategoryView.vue
功能：名單管理首頁
作者：i9400538 陳博承
完成：2021-06-17
-->
<template>
  <main>
    <tab-header />
    <div class="tab-pane active show">
      <form class="form">
        <section class="segment segment-padding">
          <h3>名單專區總覽</h3>
          <div class="release-filter-box">
            <label class="mb-1">發佈狀態</label>
            <select
              :id="`status-${colKey}`"
              :data-vv-name="`status-${colKey}`"
              class="form-control form-control-inline me-2"
              v-model="release_type"
              v-validate="'required'"
              data-vv-as="發佈狀態"
              :class="{ 'is-invalid': errors.has(`status-${colKey}`) }"
              style="display: inline-block;"
            >
              <option value="-1">全部</option>
              <option value="0">待發佈</option>
              <option value="1">發佈中</option>
              <option value="2">已下架</option>
            </select>
            <a class="btn btn-primary" @click="doQuery('')">查詢</a>
          </div>
          <span class="text-green" style="font-weight: bold;">明細列表：共{{categoryList.length}}筆</span>
          <div class="row mt-1">
            <section class="w-100">
              <table id="added_datatable" class="table datatable table-striped area-list-datatable">
                <thead>
                  <tr>
                    <th
                      id="col_ser_no"
                      :class="'sorting ' + (order.fieldName == 'ser_no' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('ser_no')"
                      class="text-center"
                    >名單序號</th>
                    <th
                      id="col_category_name"
                      :class="'sorting ' + (order.fieldName == 'category_name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('category_name')"
                    >名單名稱</th>
                    <th
                      id="col_category"
                      :class="'sorting ' + (order.fieldName == 'category' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('category')"
                      class="text-center"
                    >大類</th>
                    <th
                      id="col_subcategory"
                      :class="'sorting ' + (order.fieldName == 'subcategory' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('subcategory')"
                      class="text-center"
                    >中類</th>
                    <th
                      id="col_upload_date"
                      :class="'sorting ' + (order.fieldName == 'upload_date' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('upload_date')"
                      class="text-center"
                    >上架日期</th>
                    <th
                      id="col_end_date"
                      :class="'sorting ' + (order.fieldName == 'end_date' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('end_date')"
                      class="text-center"
                    >下架日期</th>
                    <th id="col_approval_status" 
                        class="text-center"
                        :class="'sorting ' + (order.fieldName == 'approval_status' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="processList('approval_status')"
                    >審核進度</th>
                    <th id="col_release_status" 
                        ref="lastCol" 
                        class="text-center"
                        :class="'sorting ' + (order.fieldName == 'release_status' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="processList('release_status')"
                    >發佈狀態</th>
                  </tr>
                </thead>
                <tbody id="area" v-if="categoryList.length" :style="`height: ${dt_height}px`">
                  <tr
                    v-for="(item, index) in categoryList"
                    :key="`td-categoryList-${index}-${item.id}`"
                  >
                    <td class="text-center" width="120px">
                      {{item.ser_no}}
                    </td>
                    <td>
                      <a
                          href="javascript:void(0);"
                          class="text-green text-underline pointer-cursor font-weight-bold"
                          @click="doEdit(item, true)"
                        >
                          {{item.category_name}}
                      </a>
                    </td>
                    <td class="text-center">{{item.category}}</td>
                    <td class="text-center">{{item.subcategory}}</td>
                    <td class="text-center">
                      <div class="date">{{item.upload_date | dateFormat}}</div>
                    </td>
                    <td class="text-center">
                      <div class="date">{{item.end_date | dateFormat}}</div>
                    </td>
                    <td :width="iPadWidth" class="text-center">
                      <span
                          v-if="item.approval_status == 0" class="text-gray font-weight-bold"
                        >
                          已審核
                      </span>
                      <span
                          v-else-if="item.approval_status == 1 && item.input_id == $store.state.userInfo.id"
                          class="text-green font-weight-bold"
                        >
                          待審核
                      </span>
                      <a
                          v-else
                          href="javascript:void(0);"
                          class="text-green text-underline pointer-cursor font-weight-bold"
                          @click="doEdit(item, false)"
                        >
                          待審核
                      </a>
                    </td>
                     <td class="text-center text-gray font-weight-bold">{{formatReleaseStatus(item.upload_date, item.end_date)}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" class="empty">
                      <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                    </td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
        </section>
      </form>
    </div>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
//component
import TabHeader from "@/desktop/components/backend/TabHeader";
import mxMask from "@/desktop/components/mxMask";
//service
import { callCategoryProcess } from "@/service";
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "CategoryView",
  mixins: [commonMixin],
  components: {
    TabHeader,
    mxMask
  },
  data() {
    return {
      categoryList: [], //所有名單
      categoryData: [], //大分類資料
      subCategoryData: [], //中分類資料
      allCategoryName: [], //所有名單名稱
      dt_height: 0, //DataTable高度
      order: {
        fieldName: "category_name",
        asc: true
      },
      mxMaskOpen: false,
      scrollPostion: 25, // 顯示當前位置
      scrollPostionOffset: 10, // 1次render筆數
      iPadWidth: 364,
      colKey: 'search',
      release_type: '-1',
    };
  },
  watch: {
    categoryList() {
      this.registerHanlink();
    }
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"])
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //欄位排序
    processList(fieldName) {
      let order = this.order;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "upload_date":
        case "end_date":
          setTimeout(() => {
            this.categoryList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.categoryList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    doQuery(){
      this.init()
    },
    //初始化
    init() {
      this.mxMaskOpen = true; //開啟遮罩
      //取得名單管理資料
      callCategoryProcess(this.$store.state.userInfo.id, "1", null).then(
        res => {
          this.mxMaskOpen = false; //關閉遮罩
          if (
            res.header &&
            res.header.status === "200" &&
            res.body.result &&
            res.body.categorylist &&
            res.body.subcategorylist
          ) {
            this.categoryList = [...res.body.result]; //名單資料
            this.categoryData = [...res.body.categorylist]; //大分類
            this.subCategoryData = [...res.body.subcategorylist]; //中分類
            this.categoryList.forEach(item => {
              this.allCategoryName.push(item.category_name); //所有名單名稱
            });

            this.setReleaseStatus()
            if(this.release_type != '-1'){
              this.categoryList = this.categoryList.filter(item => item.release_status == this.release_type)
            }    
          } else {
            //執行出錯,顯示錯誤訊息
            this.$toast.info({ title: res.header.message });
          }
          this.resetPosition();
        }
      );
    },
    //畫面初始化(卷軸, 表格高度)
    resetPosition() {
      this.scrollPostion = 25;
      this.scrollPostionOffset = 10;
      //this.dt_height = $(window).height() - 290;
      const rowHeight = 57.6;
      const rowCount = this.categoryList.length;
      // 如果沒有資料，設定為最小高度 100
      this.dt_height = rowCount ? rowHeight * rowCount : 100;
    },
    formatReleaseStatus(s_date, e_date){
          const [sy, sm, sd] = s_date.split('-').map(Number);
          const startDate = new Date(sy, sm - 1, sd);

          let endDate = null;
          if (e_date) {
            const [ey, em, ed] = e_date.split('-').map(Number);
            endDate = new Date(ey, em - 1, ed);
          }

          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          if (endDate) endDate.setHours(0, 0, 0, 0);

          if (currentDate < startDate) {
            return '待發佈';
          }

          if (endDate && currentDate > endDate) {
            return '已下架';
          }

          return '發佈中';
    },
    setReleaseStatus(){
      this.categoryList.forEach(item => {
        const statusText = this.formatReleaseStatus(item.upload_date, item.end_date);
        let statusCode = '';

        if (statusText === '待發佈') {
          statusCode = '0';
        } else if (statusText === '發佈中') {
          statusCode = '1';
        } else if (statusText === '已下架') {
          statusCode = '2';
        }

        this.$set(item, 'release_status', statusCode);
      });
    },
    //編輯
    doEdit(category, isFromSubject) {
      this.editFromSubject = isFromSubject
      this.$router.push({
        name: "backend-tab1-2",
        params: {
          categoryData: this.categoryData,
          subCategoryData: this.subCategoryData,
          categoryInfo: category,
          allCategoryName: this.allCategoryName,
          isFromSubject: isFromSubject
        }
      });
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    }
  },
  beforeMount() {
    //檢查使用者是否為通路科/數支科的人
    //檢查使用者是否有後台管理權限
    let divNo = this.UserInfo.divNo;
    let functionId = this.UserInfo.functionId || [];
    if (
      divNo !== "9400400" &&
      divNo !== "9N00200" &&
      !functionId.includes("4")
    ) {
      this.$router.push({ path: "/" });
    }
  },
  mounted() {
    this.initColWidth();
    this.init();
    let self = this;
    $(window).bind("orientationchange", function() {
      $(window).one("resize", function() {
        self.dt_height = $(window).height() - 310;
        self.iPadWidth = self.$refs.lastCol.clientWidth;
        this.initColWidth();
      });
    });
  }
};
</script>

<style lang="scss" scoped>
.segment-padding {
  padding: 1px 40px 10px 40px;
}
.text-center {
  text-align: center;
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
.segment {
  position: relative; /* 為了讓內部絕對定位生效 */
}

.release-filter-box {
  position: absolute;
  top: 30px; /* 你測試過覺得 OK 的位置 */
  right: 40px;
  z-index: 10;
  background: #fff;
  display: flex;              /* 水平排列 */
  align-items: center;        /* 垂直置中 */
  gap: 5px;                   /* 元素間距（可依實際調整） */
}
</style>
